<template>
  <div class="w-full h-full flex flex-col">
    <Loading v-show="loading" :loading="loading" />
    <div class="flex-1 overflow-y-auto">
      <div class="grid grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-10">
        <RadioBoxControl v-for="candidate in candidates" :key="candidate.code" :candidate="candidate"
          :isSelected="selectedVotes.includes(candidate.code)" :is_bod="true" @select="toggleVote" />
      </div>
    </div>
  </div>

  <ModalControl v-show="show_message_modal" :display="show_message_modal" :error="error" :success="success"
    :note="warning" z_value="z-50" @positiveClick="handlePositiveClick" :positiveButton="'OK'"
    :default_width="'max-w-xl'" id="vote_modal">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-lg lg:text-xl text-center">
      {{ modal_message }}
    </div>
  </ModalControl>

  <ModalControl v-show="complete_modal" :display="complete_modal" :note="true" z_value="z-50"
    @positiveClick="handlePositiveClick" :positiveButton="'OK'" :default_width="'max-w-xl'" id="vote_modal">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-lg lg:text-xl text-center">
      <p> You have already selected the maximum number of candidates for <span class="font-bold">{{ category }}</span>
        category. Please deselect a candidate and select again.</p>
    </div>
  </ModalControl>
  
  
  <ModalControl v-show="ack_notice" :display="ack_notice" :note="true" z_value="z-50"
    @positiveClick="ackNotice" :positiveButton="'OK'" :default_width="'max-w-xl'" id="vote_modal">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-base lg:text-lg text-center">
        <p class="mb-2 lg:mb-10">Please select Eight (8) Candidates for the Board of Directors Position.</p>
        <p class="p-2 lg:p-4 rounded-full px-10 my-2 lg:my-4 bg-gray-100 w-auto">3 - Officer</p>
        <p class="p-2 lg:p-4 rounded-full px-10 my-2 lg:my-4 bg-gray-100 w-auto">3 - Enlisted Personnel</p>
        <p class="p-2 lg:p-4 rounded-full px-10 my-2 lg:my-4 bg-gray-100 w-auto">2 - Civilian</p>
    </div>
  </ModalControl>

</template>

<script>
import { defineComponent } from 'vue';
import Loading from '@/components/controls/LoadingControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import RadioBoxControl from '@/components/controls/RadioBoxControl.vue';

export default defineComponent({
  components: {
    Loading,
    ModalControl,
    RadioBoxControl,
  },

  data() {
    return {
      loading: false,
      show_message_modal: false,
      complete_modal: false,
      modal_message: '',
      success: false,
      warning: false,
      error: false,
      category: '',
      ack_notice: false,
    };
  },
  mounted() {
    this.openNotice();
  },
  watch: {
    isCompleted: {
      immediate: true,
      handler(val) {
        this.$emit('completed', val);
      }
    }
  },
  computed: {
    isCompleted() {
      return (
        this.officerCount === 3 &&
        this.epCount === 3 &&
        this.civilianCount === 2 &&
        this.selectedVotes.length === 8
      );
    },
    selectedVotes() {
      return this.$store.state.selectedVotes.bod;
    },
    candidates() {
      const bod = this.$store.state.gaCandidates?.bod || [];
      return bod.map(c => ({
        code: c.code,
        name: c.name,
        type: c.type,
        image: c.photo
      }));
    },
    selectedCandidates() {
      return this.candidates.filter(c =>
        this.selectedVotes.includes(c.code)
      );
    },
    officerCount() {
      return this.selectedCandidates.filter(c => c.type === 'OFFICER').length;
    },

    epCount() {
      return this.selectedCandidates.filter(c => c.type === 'ENLISTED PERSONNEL').length;
    },

    civilianCount() {
      return this.selectedCandidates.filter(c => c.type === 'CIVILIAN').length;
    },
  },
  methods: {
    openNotice() {
      if (this.$store.state.ackNotice.bod) {
        this.ack_notice = false;
      } else {
        this.ack_notice = true;
      }
    },
    ackNotice() {
      this.ack_notice = false;
      this.$store.state.ackNotice.bod = true;
    },
    clearVotes() {
      this.selectedVotes = [];
    },
    toggleVote(candidate) {
      const index = this.selectedVotes.indexOf(candidate.code);

      // ✅ FIRST: if already selected → deselect (NO LIMIT CHECK)
      if (index !== -1) {
        const updated = [...this.selectedVotes];
        updated.splice(index, 1);
        this.$store.commit('setSelectedVotes', { category: 'bod', votes: updated });
        return;
      }

      // ✅ SECOND: enforce category limits
      if (candidate.type === 'OFFICER' && this.officerCount >= 3) {
        this.category = 'Officer';
        this.complete_modal = true;
        return;
      }

      if (candidate.type === 'ENLISTED PERSONNEL' && this.epCount >= 3) {
        this.category = 'Enlisted Personnel';
        this.complete_modal = true;
        return;
      }

      if (candidate.type === 'CIVILIAN' && this.civilianCount >= 2) {
        this.category = 'Civilian';
        this.complete_modal = true;
        return;
      }

      // ✅ THIRD: total limit
      if (this.selectedVotes.length < 8) {
        const updated = [...this.selectedVotes, candidate.code];
        this.$store.commit('setSelectedVotes', { category: 'bod', votes: updated });
      }
    },

    handlePositiveClick() {
      this.show_message_modal = false;
      this.complete_modal = false;
    }
  }
});
</script>

<style scoped>
.max-width-back {
  max-width: 50px;
}
</style>
